import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import ColumnHeaderProps from '@components/SchedulePage/types/ColumnHeaderProps';
import NonBlockColumnHeader from '@components/SchedulePage/NonBlockColumnHeader/NonBlockColumnHeader';
import {
	getBlockColumnHeaderDetails,
} from '@components/SchedulePage/utilities/getBlockColumnHeaderDetails/getBlockColumnHeaderDetails';
import BlockType from '@data/schedules/types/BlockType';
import AdditionalBlocks from '@components/SchedulePage/AdditionalBlocks/AdditionalBlocks';

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			padding: theme.spacing(0.5, 1, 0.5, 1),
			backgroundColor: theme.palette.grey[800],
			color: theme.palette.common.white,
			display: 'flex',
			flexDirection: 'column',
			borderRadius: '4px 4px 0 0',
		},
		blockText: {
			fontWeight: 600,
		},
		additionalBlocks: {
			padding: theme.spacing(0.5, 1, 0.5, 1),
			backgroundColor: theme.palette.primary.dark,
		},
	}),
);

const BlockReleasedColumnHeader: React.FC<ColumnHeaderProps> = ({ blockInfo, children }) => {
	const classes = useStyles();

	const hasSurgeonBlock = blockInfo.blocks?.some((block) => block.type === BlockType.SURGEON);
	const { hasAdditionalBlocks } = React.useMemo(() => getBlockColumnHeaderDetails(blockInfo), [blockInfo]);
	return (
		<>
			{hasSurgeonBlock && (
				<Box
					className={classes.root}
					data-field="block-released-column-header"
					component="header"
				>
					<Typography variant="body2" component="h3" className={classes.blockText}>
						Surgeon Block - RELEASED
					</Typography>

					{children}
				</Box>
			)}
			{hasAdditionalBlocks &&
				<Box className={classes.additionalBlocks}>
					<AdditionalBlocks blockInfo={blockInfo} />
				</Box>
			}
			{!hasAdditionalBlocks && <NonBlockColumnHeader blockInfo={blockInfo} />}
		</>
	);
};

export default BlockReleasedColumnHeader;
